import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class LeadScoreAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/lead-score', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead-score/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/lead-score', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/lead-score/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default LeadScoreAPI;